import DeleteIcon from "@mui/icons-material/Delete";
import AcxMainTextField from "components/UI/AcxMainTextField";
import React from "react";

type ServiceSetupRowProps = {
    item: string;
    updateRow: (val: string) => void;
    removeRow: () => void;
    error?: string;
    disabled?: boolean;
};

const ServiceSetupRow: React.FC<
    React.PropsWithChildren<React.PropsWithChildren<ServiceSetupRowProps>>
> = ({ item, removeRow, updateRow, error, disabled }) => {
    return (
        <div
            style={{
                width: "100%",
                borderRadius: "4px",
                backgroundColor: "#f4f4f4",
                marginTop: "12px",
            }}
        >
            <div style={{ padding: 8 }}>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        lineHeight: "0px",
                    }}
                >
                    <div style={{ paddingRight: "12px", flexGrow: 1 }}>
                        <AcxMainTextField
                            id="name"
                            value={item}
                            onChange={(e) => updateRow(e.target.value)}
                            error={!!error}
                            helperText={error}
                            isDisabled={disabled}
                            showAllErrors={true}
                        />
                    </div>
                    {!disabled && (
                        <div style={{ paddingRight: "8px" }}>
                            <DeleteIcon
                                htmlColor="#bebebe"
                                onClick={removeRow}
                                cursor="pointer"
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ServiceSetupRow;
